import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ToastProvider } from './components/ToastNotification'
import App from './App'
import { seedMockCommunities } from './data/mockCommunities'
import './i18n/i18n'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'

// Create QueryClient for data fetching
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

// Only seed mock communities when explicitly enabled via environment variable.
// In production, all data should come from the real backend API.
if (import.meta.env.VITE_SEED_MOCK === 'true') {
  seedMockCommunities(queryClient)
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)
